import { call } from '../@';

export type ConfirmTransactionDatesDto = {
	id: string;
	exchangeDate: Date;
	completionDate: Date;
};

export default async function confirmTransactionDates(payload: ConfirmTransactionDatesDto) {
	return await call('transaction-confirmDates', payload);
}
